import { createTheme } from "@mui/material/styles";
import { palette } from "./tokens";

// SEED IMS Theme
// Matches the modern design from dashboard.module.css
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: palette.primary.main,
      dark: palette.primary.dark,
      light: palette.primary.light
    },
    secondary: {
      main: palette.secondary.main,
      dark: palette.secondary.dark,
      light: palette.secondary.light
    },
    background: {
      default: palette.background.default,
      paper: palette.background.paper
    },
    text: {
      primary: palette.text.primary,
      secondary: palette.text.secondary
    },
    success: {
      main: palette.success.main
    },
    error: {
      main: palette.error.main
    },
    warning: {
      main: palette.warning.main
    },
    info: {
      main: palette.info.main
    }
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: "2rem"
    },
    h4: {
      fontWeight: 700,
      fontSize: "2rem"
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.05rem"
    },
    body1: {
      fontSize: "0.95rem"
    },
    body2: {
      fontSize: "0.9rem"
    }
  },
  shape: {
    borderRadius: 10 // Consistent with dashboard rounded corners
  },
  shadows: [
    "none",
    "0 4px 12px rgba(15, 23, 42, 0.08)", // Matches --seed-shadow
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)",
    "0 4px 12px rgba(15, 23, 42, 0.08)"
  ],
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.secondary.main, // Grenada Green sidebar
          color: "#edf2fb"
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: palette.secondary.main, // Grenada Green sidebar
          color: "#edf2fb"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none"
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16
        },
        outlined: {
          borderRadius: 16
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: "4px 8px",
          "&.Mui-selected": {
            backgroundColor: "rgba(255, 255, 255, 0.15)",
            color: "#fff",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.22)"
            }
          },
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "#fff"
          }
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          minWidth: 40
        }
      }
    }
  }
});
